<template>
  <div class="no-process">
        <svg class="no-process__symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
            <path class="a" d="M3.94,12.89A1,1,0,0,1,4.4,13L35.87,31.19a.94.94,0,0,1,0,1.62L4.4,51a1,1,0,0,1-.46.13A1,1,0,0,1,3,50.17V13.83a1,1,0,0,1,.94-.94m0-3A3.94,3.94,0,0,0,0,13.83V50.17a3.94,3.94,0,0,0,3.94,3.94,3.87,3.87,0,0,0,2-.54L37.37,35.41a3.94,3.94,0,0,0,0-6.82L5.9,10.43a3.87,3.87,0,0,0-2-.54Z"/>
            <path class="a" d="M28.61,12.89a1,1,0,0,1,.46.13L60.53,31.19a.93.93,0,0,1,0,1.62L29.07,51a1,1,0,0,1-.46.13,1,1,0,0,1-.94-.94V13.83a1,1,0,0,1,.94-.94m0-3a3.94,3.94,0,0,0-3.94,3.94V50.17a3.94,3.94,0,0,0,3.94,3.94,3.9,3.9,0,0,0,2-.54L62,35.41a3.93,3.93,0,0,0,0-6.82L30.57,10.43a3.9,3.9,0,0,0-2-.54Z"/>
        </svg>
        <h5 class="no-process__text">
            {{$t("process.select_from_list")}}
        </h5>
        <a class="no-process__link" href="">
            <p class="attensi-body1">
                {{$t("process.click_here_for_help")}}
            </p>
        </a>
    </div>
</template>

<style lang="scss" scoped>
    .no-process{
        height: 100%;
        width: 100%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .no-process__symbol{
            max-width: 40px;
            max-height: 40px;
        }
        .no-process__text{
            margin: 20px 0;
        }
        .no-process__link{
            margin-bottom: 10%;
        }
    }

</style>

<script>
export default {
  
}
</script>
